import React from "react";

const Prizes = () => (
  <section id="prizes">
    <div className="container">
      <div className="title-block">
        <h2>Prizes</h2>
        <p>The Top 3 teams and the Most Creative Team from each category will win attractive cash prizes!</p>
      </div>
      <div className="row">
        <div className="col-md-6">
          <div className="box">
            <img src="images/icon_reward.svg" className="img-fluid" alt="" />
            <div className="row">
              <div className="col-md-9 offset-md-3 col-12">
                <h4>Champion</h4>
                <ul>
                  <li>SGD <span className="price">3000</span></li>
                  <li>Full-time / internship opportunities in Shopee</li>
                  <li>Return ticket to visit Shopee Shenzhen Tech Centre</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="box">
            <img src="images/icon_reward_silver.svg" className="img-fluid" alt="" />
            <div className="row">
              <div className="col-md-9 offset-md-3 col-12">
                <h4>1<sup>st</sup> Runner-up</h4>
                <ul>
                  <li>SGD <span className="price">2000</span></li>
                  <li>Full-time / internship opportunities in Shopee</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="box">
            <img src="images/icon_reward_silver.svg" className="img-fluid" alt="" />
            <div className="row">
              <div className="col-md-9 offset-md-3 col-12">
                <h4>2<sup>nd</sup> Runner-up</h4>
                <ul>
                  <li>SGD <span className="price">1000</span></li>
                  <li>Full-time / internship opportunities in Shopee</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="box">
            <img src="images/icon_reward_copper.svg" className="img-fluid" alt="" />
            <div className="row">
              <div className="col-md-9 offset-md-3 col-12">
                <h4>Most Creative Team</h4>
                <ul>
                  <li>SGD <span className="price">800</span></li>
                  <li>Full-time / internship opportunities in Shopee</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="note">
        <p>All participants will receive a certificate of accomplishment at the end of the award ceremony only if their project has been submitted successfully before the deadline.</p>
      </div>
    </div>
  </section>
);

export default Prizes;